module.exports = __webpack_public_path__ + "static/txtling3-150x150-4571971b31282b9cb23f03527ba14f68.png";